import React from "react";

function Banner() {
  return (
    <>
      {/* BANNER */}
      <div className="w-full bg-red-">
        <div className="w-full md:w-10/12 lg:w-7/12 mx-auto flex flex-row items-center justify-between bg-green- py-8">
          {/* Image 1 */}
          <div className="w-3/12">
            <img src="https://demo.tagdiv.com/newspaper_pro/wp-content/uploads/2019/09/np10blue-retina.png" />
          </div>

          {/* Image 2 */}
          <div className="">
            <img src="https://demo.tagdiv.com/newspaper_pro/wp-content/uploads/2019/08/newspaper-rec728.jpg" />
          </div>
        </div>
      </div>
    </>
  );
}

export default Banner;
